/* ============================================================================
   OLBIY SARI KREM — 2026 v2 · Shopify section script
   Tüm sorgular .olbv2 sarmalayıcısının içine kilitlidir; tema JS'ine dokunmaz.
   Paket verileri Liquid tarafından basılan data-* niteliklerinden okunur.
   ============================================================================ */
(function () {
  'use strict';

  var ROOT = document.querySelector('[data-olbv2]');
  if (!ROOT) return;

  var CFG = window.OLBV2 || {};
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, r) { return (r || ROOT).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || ROOT).querySelectorAll(s)); }

  /* ------------------------------------------------------------- paketler */
  var firstList = $('[data-pkgs]');
  var PKGS = [];
  if (firstList) {
    $$('.o2-pkg', firstList).forEach(function (el) {
      PKGS.push({
        i:     Number(el.dataset.i),
        vid:   el.dataset.vid,
        qty:   Number(el.dataset.qty) || 1,
        gift:  Number(el.dataset.gift) || 0,
        tot:   Number(el.dataset.totalQty) || Number(el.dataset.qty) || 1,
        price: el.dataset.priceText || '',
        unit:  el.dataset.unitText || '',
        save:  el.dataset.saveText || '',
        cmp:   el.dataset.cmpText || '',
        pct:   Number(el.dataset.pct) || 0,
        avail: el.dataset.avail !== '0'
      });
    });
  }
  if (!PKGS.length) return;

  var start = Number(CFG.defaultIndex);
  if (!isFinite(start) || !PKGS[start]) start = 0;
  if (!PKGS[start].avail) {
    for (var k = 0; k < PKGS.length; k++) { if (PKGS[k].avail) { start = k; break; } }
  }
  var SEL = PKGS[start];

  function pkgLabel(p) {
    return p.qty + (p.gift > 0 ? '+' + p.gift : '') + ' Kutu' + (p.gift > 0 ? ' (' + p.gift + ' kutu hediye)' : '');
  }

  function sync() {
    var giftBit = SEL.gift > 0 ? ' · ' + SEL.gift + ' kutu hediye dahil' : '';
    var sub = SEL.tot + ' kutu · adet başı ' + SEL.unit + giftBit;

    $$('[data-total]').forEach(function (e) { e.textContent = SEL.price; });
    $$('[data-cta-sub]').forEach(function (e) { e.textContent = sub; });
    $$('[data-dock-title]').forEach(function (e) {
      e.textContent = (SEL.gift > 0 ? '🎁 ' : '') + SEL.qty + (SEL.gift > 0 ? '+' + SEL.gift : '') + ' Kutu · ' + SEL.price;
    });
    $$('[data-dock-sub]').forEach(function (e) {
      e.textContent = 'Kapıda ödeme · Kargo bedava' + (SEL.gift > 0 ? ' · ' + SEL.gift + ' kutu hediye' : (SEL.save ? ' · ' + SEL.save + ' tasarruf' : ''));
    });

    /* modaldaki hediye satırı */
    $$('[data-mgift]').forEach(function (e) {
      if (SEL.gift > 0) {
        var t = e.querySelector('[data-mgift-title]');
        if (t) t.textContent = SEL.gift + ' Kutu Olbiy Sarı Krem — Hediye';
        e.hidden = false;
      } else { e.hidden = true; }
    });

    $$('.o2-pkg').forEach(function (c) { c.classList.toggle('o2-on', Number(c.dataset.i) === SEL.i); });
    $$('.o2-gpill').forEach(function (c) { c.classList.toggle('o2-on', Number(c.dataset.i) === SEL.i); });
    $$('.o2-ocard').forEach(function (c) {
      var on = Number(c.dataset.i) === SEL.i;
      c.classList.toggle('o2-on', on);
      var pick = $('.o2-oc-pick', c);
      if (pick) pick.textContent = on ? 'Seçildi' : 'Bu paketi seç';
    });

    /* modal toplam satırı: indirim rozeti + üstü çizili eski fiyat */
    $$('[data-ind-pill]').forEach(function (e) {
      if (SEL.pct > 0) { e.textContent = '-%' + SEL.pct; e.hidden = false; } else { e.hidden = true; }
    });
    $$('[data-total-old]').forEach(function (e) {
      if (SEL.cmp) { e.textContent = SEL.cmp; e.hidden = false; } else { e.hidden = true; }
    });

    /* WhatsApp formu: seçili paket çipi + özet satırı */
    $$('[data-wf-pkt]').forEach(function (c) { c.classList.toggle('o2-sel', Number(c.dataset.i) === SEL.i); });
    $$('[data-wa-ozet]').forEach(function (e) {
      e.textContent = '📦 ' + pkgLabel(SEL) + ' · ' + SEL.price + ' · ' + (CFG.waNote || 'Kargo bedava · Kapıda ödeme');
    });
  }

  ROOT.addEventListener('click', function (e) {
    var card = e.target.closest('.o2-pkg,.o2-ocard,.o2-gpill');
    if (!card || card.disabled) return;
    var p = PKGS[Number(card.dataset.i)];
    if (!p || !p.avail) return;
    var changed = p.i !== SEL.i;
    SEL = p;
    sync();
    /* hediyeli paket seçildiğinde altın parıltı */
    if (changed && !REDUCE && p.gift > 0) {
      $$('.o2-pkg,.o2-ocard,.o2-gpill').forEach(function (c) {
        if (Number(c.dataset.i) !== p.i) return;
        c.classList.remove('o2-pop');
        void c.offsetWidth;
        c.classList.add('o2-pop');
      });
    }
  });

  /* --------------------------------------------------------------- modal */
  var orderModal = $('#o2-order');
  var legalModal = $('#o2-legal');
  var lastFocus = null;

  function openModal(m) {
    if (!m) return;
    lastFocus = document.activeElement;
    m.classList.add('o2-open');
    m.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var x = $('.o2-modal-x', m); if (x) x.focus();
  }
  function closeModal(m) {
    if (!m) return;
    m.classList.remove('o2-open');
    m.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  ROOT.addEventListener('click', function (e) {
    var buyBtn = e.target.closest('.o2-js-buy');
    if (buyBtn) {
      /* smart (varsayılan): paket seçicinin İÇİNDEKİ buton doğrudan ödemeye gider,
         sayfadaki diğer tüm butonlar önce paket onay modalını açar.
         direct: hepsi doğrudan · modal: hepsi modal */
      var mode = CFG.buyAction || 'modal';
      var inBox = !!buyBtn.closest('.o2-buybox');
      var goDirect = (mode === 'direct') || (mode === 'smart' && inBox);
      /* modal modunda hiçbir buton doğrudan ödemeye gitmez:
         müşteri önce paketleri görür, daha büyük pakete geçme şansı olur */
      if (goDirect) { doCheckout(buyBtn); } else { openModal(orderModal); }
      return;
    }
    if (e.target.closest('.o2-modal-x')) { closeModal(e.target.closest('.o2-modal')); return; }
    if (e.target.classList && e.target.classList.contains('o2-modal')) { closeModal(e.target); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { $$('.o2-modal.o2-open').forEach(closeModal); return; }
    if (e.key !== 'Tab') return;
    var m = $('.o2-modal.o2-open'); if (!m) return;
    var f = $$('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])', m)
              .filter(function (el) { return !el.disabled && el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ------------------------------------------- sepete ekle → ödeme sayfası */
  var addBtn = $('[data-add]');
  var errBox = $('[data-cart-err]');
  var busy = false;
  var busyBtn = null;

  function unbusy() {
    busy = false;
    if (busyBtn) { busyBtn.disabled = false; busyBtn.classList.remove('o2-busy'); busyBtn = null; }
  }

  function fail(msg) {
    unbusy();
    if (errBox) { errBox.textContent = msg || CFG.errText || 'Sipariş oluşturulamadı.'; errBox.hidden = false; }
    // Doğrudan akışta hata olursa müşteri boşlukta kalmasın: modalı aç, tekrar denesin.
    if (orderModal && !orderModal.classList.contains('o2-open')) openModal(orderModal);
  }

  /* Seçili paketi sepete ekler ve ödeme sayfasına gönderir.
     btn: basılan buton (yükleniyor durumu için) */
  function doCheckout(btn) {
    if (busy || !SEL || !SEL.vid) return;
    busy = true;
    busyBtn = btn || addBtn;
    if (busyBtn) { busyBtn.disabled = true; busyBtn.classList.add('o2-busy'); }
    if (errBox) errBox.hidden = true;

    var addUrl = CFG.cartAdd || '/cart/add.js';
    var clearUrl = CFG.cartClear || '/cart/clear.js';
    var go = CFG.afterAdd === 'cart' ? (CFG.cartUrl || '/cart') : '/checkout';

    var step = CFG.clearFirst
      ? fetch(clearUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' })
          .catch(function () { /* temizleme başarısızsa yine de devam et */ })
      : Promise.resolve();

    step.then(function () {
      return fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(SEL.vid), quantity: 1 }] })
      });
    }).then(function (r) {
      if (!r || !r.ok) {
        return r.json().then(function (d) {
          var e = new Error((d && (d.description || d.message)) || '');
          e.fromCart = true;                 // Shopify'ın kendi mesajı, müşteriye gösterilebilir
          throw e;
        });
      }
      window.location.href = go;
    }).catch(function (err) {
      // Ağ hatasının ham metni ("Failed to fetch") müşteriye gösterilmez.
      fail(err && err.fromCart && err.message ? err.message : null);
    });
  }

  /* ---------------------------------------------------------------- nudge
     En küçük paket seçiliyken sipariş butonuna basılırsa, bir kez daha
     büyük paketi nazikçe öner. "Hayır" derse akış aynen devam eder.     */
  var nudged = false;

  function nudgeTarget() {
    if (!PKGS.length) return null;
    var order = [];
    if (CFG.bestIndex >= 0 && PKGS[CFG.bestIndex]) order.push(CFG.bestIndex);
    for (var i = PKGS.length - 1; i > 0; i--) order.push(i);
    for (var k = 0; k < order.length; k++) {
      var p = PKGS[order[k]];
      if (p && p.avail && p.i > SEL.i) return p;
    }
    return null;
  }

  function showNudge(btn) {
    var t = nudgeTarget();
    if (!t) return false;
    nudged = true;
    var box = document.createElement('div');
    box.className = 'o2-nudge';
    box.innerHTML =
      '<b>' + t.qty + ' adet olsun mu?</b> Adet başı <b>' + t.unit + '</b>' +
      (t.save ? ' — toplam <b>' + t.save + '</b> cebinde kalır.' : '.') +
      '<span class="o2-ng-btns">' +
        '<button type="button" class="o2-ng-yes">Evet, ' + t.qty + ' olsun</button>' +
        '<button type="button" class="o2-ng-no">Hayır, böyle iyi</button>' +
      '</span>';
    btn.parentNode.insertBefore(box, btn);
    try { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    box.querySelector('.o2-ng-yes').addEventListener('click', function () {
      SEL = t; sync(); box.remove();
      try { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    });
    box.querySelector('.o2-ng-no').addEventListener('click', function () {
      box.remove(); doCheckout(btn);
    });
    return true;
  }

  if (addBtn) addBtn.addEventListener('click', function () {
    if (CFG.nudge !== false && !nudged && SEL.i === 0 && PKGS.length > 1) {
      if (showNudge(addBtn)) return;
    }
    doCheckout(addBtn);
  });

  /* ------------------------------------------- WHATSAPP HIZLI SİPARİŞ ------ */
  var waOv = $('[data-wa-ov]');

  function waNum() { return (CFG.whatsapp || '905320524673').replace(/\D/g, ''); }

  function waSend(msg) {
    var url = 'https://wa.me/' + waNum() + '?text=' + encodeURIComponent(msg);
    var w = null;
    try { w = window.open(url, '_blank'); } catch (err) {}
    if (!w) window.location.href = url;   /* pop-up engellenirse aynı sekmede aç */
  }

  /* Form markup'ı yoksa (ayar kapalıysa) hazır şablonlu mesajla devam et */
  function waLegacy() {
    waSend('Merhaba 👋 Sipariş vermek istiyorum:\n'
      + '📦 Ürün: ' + (CFG.waProduct || 'Olbiy Sarı Krem') + '\n'
      + '🔢 Paket: ' + pkgLabel(SEL) + ' — ' + SEL.price + '\n'
      + '👤 Ad Soyad: \n📞 Telefon: \n📍 Teslimat adresi: \n'
      + '💵 Ödeme: Kapıda ödeme');
  }

  function waOpen() {
    if (!waOv) return waLegacy();
    /* sipariş modalı açıksa kapat — form arkada kalmasın (iOS katman sorunu) */
    if (orderModal && orderModal.classList.contains('o2-open')) {
      orderModal.classList.remove('o2-open');
      orderModal.setAttribute('aria-hidden', 'true');
    }
    sync();
    var saat = $('[data-wa-saat]', waOv);
    if (saat) {
      var d = new Date();
      saat.textContent = (d.getHours() < 10 ? '0' : '') + d.getHours() + ':' + (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
    }
    var err = $('[data-wf-err]', waOv); if (err) err.hidden = true;
    waOv.hidden = false;
    void waOv.offsetWidth;                /* senkron reflow: mobilde geçiş garantisi */
    waOv.classList.add('o2-open');
    waOv.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      var f = $('input[name="ad"]', waOv);
      if (f && !f.value) { try { f.focus({ preventScroll: true }); } catch (e) {} }
    }, 280);
  }

  function waClose() {
    if (!waOv) return;
    waOv.classList.remove('o2-open');
    waOv.setAttribute('aria-hidden', 'true');
    setTimeout(function () { waOv.hidden = true; }, 300);
    if (!orderModal || !orderModal.classList.contains('o2-open')) document.body.style.overflow = '';
  }

  /* Tetikleyiciler — delegasyon (sonradan eklenen butonlar da çalışır) */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-wa-order]') : null;
    if (t && ROOT.contains(t)) { e.preventDefault(); waOpen(); return; }
    var c = e.target && e.target.closest ? e.target.closest('[data-wa-close]') : null;
    if (c && ROOT.contains(c)) { e.preventDefault(); waClose(); }
  });

  if (waOv) {
    waOv.addEventListener('click', function (e) { if (e.target === waOv) waClose(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && waOv.classList.contains('o2-open')) waClose();
    });

    /* paket çipleri */
    $$('[data-wf-pkt]', waOv).forEach(function (b) {
      b.addEventListener('click', function () {
        var p = PKGS[Number(b.dataset.i)];
        if (!p || !p.avail) return;
        SEL = p; sync();
      });
    });

    /* telefon maskesi: 0 5XX XXX XX XX */
    var telInp = $('input[name="tel"]', waOv);
    if (telInp) {
      telInp.setAttribute('maxlength', '14');
      telInp.addEventListener('input', function () {
        var d = this.value.replace(/\D/g, '');
        if (d.slice(0, 2) === '90') d = d.slice(2);
        if (d.charAt(0) === '0') d = d.slice(1);
        d = d.slice(0, 10);
        var out = '';
        if (d.length) {
          out = '0' + d.slice(0, 3);
          if (d.length > 3) out += ' ' + d.slice(3, 6);
          if (d.length > 6) out += ' ' + d.slice(6, 8);
          if (d.length > 8) out += ' ' + d.slice(8, 10);
        } else if (this.value.indexOf('0') !== -1) { out = '0'; }
        this.value = out;
        this.classList.remove('o2-wf-eksik');
      });
    }

    var waForm = $('[data-wa-form]', waOv);
    if (waForm) {
      $$('input,textarea', waForm).forEach(function (el) {
        el.addEventListener('input', function () {
          el.classList.remove('o2-wf-eksik');
          var e0 = $('[data-wf-err]', waOv);
          if (e0 && !$$('.o2-wf-eksik', waForm).length) e0.hidden = true;
        });
      });

      waForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var g = function (n) { var el = $('[name="' + n + '"]', waForm); return el ? el.value.trim() : ''; };
        var eksik = false;
        ['ad', 'soyad', 'tel', 'il', 'ilce', 'adres'].forEach(function (n) {
          var el = $('[name="' + n + '"]', waForm);
          if (!el) return;
          var bos = !el.value.trim();
          el.classList.toggle('o2-wf-eksik', bos);
          if (bos) eksik = true;
        });

        /* telefon: 0'dan sonra 5 ile başlayan tam 10 hane */
        var telEl = $('[name="tel"]', waForm);
        var telD = (telEl ? telEl.value : '').replace(/\D/g, '');
        if (telD.slice(0, 2) === '90') telD = telD.slice(2);
        if (telD.charAt(0) === '0') telD = telD.slice(1);
        var telOk = /^5\d{9}$/.test(telD);
        if (telEl && !telOk) telEl.classList.add('o2-wf-eksik');

        var err = $('[data-wf-err]', waOv);
        if (eksik || !telOk) {
          if (err) {
            err.textContent = (!telOk && !eksik)
              ? "Telefon numaranı kontrol et: 0'dan sonra 5 ile başlayan 10 hane olmalı (örn. 0532 123 45 67)."
              : 'Lütfen kırmızı işaretli alanları doldur.';
            err.hidden = false;
          }
          return;
        }
        if (err) { err.hidden = true; err.textContent = 'Lütfen kırmızı işaretli alanları doldur.'; }

        var telFmt = '0' + telD.slice(0, 3) + ' ' + telD.slice(3, 6) + ' ' + telD.slice(6, 8) + ' ' + telD.slice(8, 10);
        var msg = 'Merhaba 👋 Siparişimi tamamlamak istiyorum:\n'
          + '📦 Ürün: ' + (CFG.waProduct || 'Olbiy Sarı Krem') + '\n'
          + '🔢 Paket: ' + pkgLabel(SEL) + ' — ' + SEL.price + '\n'
          + '👤 Ad Soyad: ' + g('ad') + ' ' + g('soyad') + '\n'
          + '📞 Telefon: ' + telFmt + '\n'
          + '📍 Adres: ' + g('adres') + ' — ' + g('ilce') + ' / ' + g('il') + '\n'
          + '🚚 Kargo: Ücretsiz\n'
          + '💵 Ödeme: Kapıda ödeme (teslimatta)';
        waSend(msg);
        waClose();
      });
    }
  }

  /* --------------------------------------------------------------- yasal */
  var LEGAL = {
    privacy: {
      t: 'Gizlilik Politikası',
      b: '<h3>Kişisel verileriniz</h3><p>Sipariş sırasında paylaştığınız iletişim ve teslimat bilgileri; siparişinizi oluşturmak, teslimatı gerçekleştirmek ve müşteri desteği sağlamak amacıyla işlenir.</p>' +
         '<h3>Veri güvenliği</h3><p>Bilgileriniz yetkisiz erişime karşı uygun teknik ve idari önlemlerle korunur.</p>'
    },
    returns: {
      t: 'İade ve Cayma Bilgilendirmesi',
      b: '<h3>Cayma hakkı</h3><p>Mesafeli satışlarda uygulanacak cayma ve iade koşulları, yürürlükteki tüketici mevzuatı ve ürünün hijyen niteliği dikkate alınarak sipariş öncesinde alıcıya sunulur.</p>' +
         '<h3>Hasarlı veya hatalı teslimat</h3><p>Ürünün hasarlı, eksik ya da siparişten farklı ulaşması halinde satıcıyla iletişime geçerek inceleme talep edebilirsiniz.</p>'
    }
  };
  $$('[data-legal]').forEach(function (b) {
    b.addEventListener('click', function () {
      var c = LEGAL[b.dataset.legal]; if (!c) return;
      $('#o2-legalTitle').textContent = c.t;
      $('#o2-legalBody').innerHTML = c.b;
      openModal(legalModal);
    });
  });

  /* -------------------------------------------------------- hero galeri */
  var heroImg = $('.o2-hv-img');
  $$('.o2-hv-thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      var src = t.dataset.full || ($('img', t) || {}).src;
      if (!src || !heroImg) return;
      heroImg.style.opacity = '0';
      setTimeout(function () { heroImg.src = src; heroImg.style.opacity = ''; }, 140);
      $$('.o2-hv-thumb').forEach(function (x) { x.classList.toggle('o2-is-on', x === t); });
    });
  });

  /* ------------------------------------------------------- bölge seçici */
  var zImg = $('[data-zone-img]'), zTag = $('[data-zone-tag]'),
      zTitle = $('[data-zone-title]'), zText = $('[data-zone-text]');
  $$('.o2-zt').forEach(function (b) {
    b.addEventListener('click', function () {
      $$('.o2-zt').forEach(function (x) {
        var on = x === b;
        x.classList.toggle('o2-is-on', on);
        x.setAttribute('aria-selected', String(on));
      });
      if (zImg && b.dataset.img) {
        zImg.src = b.dataset.img;
        zImg.alt = b.dataset.alt || '';
        zImg.style.animation = 'none'; void zImg.offsetWidth; zImg.style.animation = '';
      }
      if (zTag) zTag.textContent = b.dataset.tag || '';
      if (zTitle) zTitle.textContent = b.dataset.title || '';
      if (zText) zText.textContent = b.dataset.text || '';
    });
  });

  /* ------------------------------------------------------------- reveal */
  var rvNodes = $$('.o2-rv');
  if ('IntersectionObserver' in window && !REDUCE) {
    var rio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('o2-in');
        rio.unobserve(e.target);
      });
    }, { threshold: .08, rootMargin: '0px 0px -40px' });
    rvNodes.forEach(function (n) {
      var idx = n.parentElement ? Array.prototype.indexOf.call(n.parentElement.children, n) : 0;
      n.style.transitionDelay = Math.min(idx, 5) * 0.07 + 's';
      rio.observe(n);
    });
  } else {
    rvNodes.forEach(function (n) { n.classList.add('o2-in'); });
  }

  /* ----------------------------------------------------------- sayaçlar */
  function runCount(el) {
    var target = parseFloat(el.dataset.count);
    if (!isFinite(target)) return;
    var dec = parseInt(el.dataset.dec, 10) || 0;
    var suf = el.dataset.suffix || '';
    function fmt(v) {
      return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: dec, maximumFractionDigits: dec }).format(v) + suf;
    }
    if (REDUCE) { el.textContent = fmt(target); return; }
    var s0 = 0, dur = 1500;
    function step(ts) {
      if (!s0) s0 = ts;
      var p = Math.min(1, (ts - s0) / dur);
      el.textContent = fmt(target * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(step); else el.textContent = fmt(target);
    }
    requestAnimationFrame(step);
  }
  var counters = $$('[data-count]');
  if (counters.length && 'IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { runCount(e.target); cio.unobserve(e.target); } });
    }, { threshold: .4 });
    counters.forEach(function (c) { cio.observe(c); });
  } else counters.forEach(runCount);

  /* -------------------------------------------------------- geri sayım */
  function parseDeadline(s) {
    s = String(s || '').trim();
    if (!s) return 0;
    var m = s.match(/^(\d{4})[-.\/](\d{1,2})[-.\/](\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);      /* 2026-10-05 23:59 */
    if (m) return new Date(+m[1], +m[2] - 1, +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59, 0).getTime();
    m = s.match(/^(\d{1,2})[-.\/](\d{1,2})[-.\/](\d{4})(?:[ T](\d{1,2}):(\d{2}))?/);          /* 05.10.2026 23:59 */
    if (m) return new Date(+m[3], +m[2] - 1, +m[1], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59, 0).getTime();
    var t = Date.parse(s);
    return isNaN(t) ? 0 : t;
  }

  (function countdown() {
    /* Geri sayım yalnızca yöneticinin girdiği GERÇEK bitiş tarihine bağlanır.
       Tarih yoksa ya da geçmişse hiçbir sayaç gösterilmez. */
    if (!CFG.countdown) return;
    var deadline = parseDeadline(CFG.deadline);
    if (!deadline) return;

    var clocks = $$('[data-timer-wrap],[data-camp-clock]');
    if (!clocks.length) return;
    var ds = $$('[data-d]'), hs = $$('[data-h]'), ms = $$('[data-m]'), ss = $$('[data-s]');
    var host = $('[data-urgency]');
    var campSub = $('.o2-cb-sub');
    var timerId = 0;

    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function put(list, v) { list.forEach(function (e) { e.textContent = pad(v); }); }

    function expire() {
      if (timerId) clearInterval(timerId);
      clocks.forEach(function (e) { e.hidden = true; });
      var tw = $('[data-timer-wrap]');
      if (host && (!tw || tw.hidden)) {
        var sw = $('[data-stock-wrap]');
        if (!sw || sw.hidden) host.hidden = true;
      }
      if (campSub) campSub.textContent = CFG.campEnd || 'Kampanya süresi doldu';
      ROOT.classList.add('o2-camp-over');
    }

    if (deadline <= Date.now()) { expire(); return; }

    clocks.forEach(function (e) { e.hidden = false; });
    if (host) host.hidden = false;

    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) { put(ds, 0); put(hs, 0); put(ms, 0); put(ss, 0); expire(); return; }
      put(ds, Math.floor(diff / 864e5));
      put(hs, Math.floor(diff % 864e5 / 36e5));
      put(ms, Math.floor(diff % 36e5 / 6e4));
      put(ss, Math.floor(diff % 6e4 / 1e3));
    }
    tick(); timerId = setInterval(tick, 1000);
  })();

  /* -------------------------------------------------------------- stok */
  (function stock() {
    var cap = Number(CFG.stockTotal), left = Number(CFG.stockLeft);
    if (!cap || !left || left > cap) return;
    var wrap = $('[data-stock-wrap]');
    if (wrap) wrap.hidden = false;
    var host = $('[data-urgency]'); if (host) host.hidden = false;
    var txt = $('[data-stock-text]'), bar = $('[data-stock-bar]');
    if (txt) txt.textContent = 'Kampanya stoğu: ' + left + ' / ' + cap + ' adet kaldı';
    if (bar) requestAnimationFrame(function () { bar.style.width = Math.max(4, Math.round(left / cap * 100)) + '%'; });
    /* modal içindeki kıtlık satırı */
    $$('[data-mstock]').forEach(function (e) {
      e.textContent = '🔥 Kampanya stoğu: son ' + left + ' adet — tükenmeden tamamla';
      e.hidden = false;
    });
  })();

  /* ------------------------------------------------- scroll bağlı işler */
  var dock = $('[data-dock]');
  var waBtn = $('.o2-wa');
  var scrub = $('[data-scrub]');
  var cycleSec = $('.o2-cycle');
  var phases = $$('.o2-phase');
  var heroVisual = $('[data-parallax]');
  var raf = 0;

  function onScroll() {
    var y = window.scrollY;
    var rect = ROOT.getBoundingClientRect();
    var rootTop = y + rect.top;
    var rootEnd = rootTop + ROOT.offsetHeight;
    var inRange = y + window.innerHeight > rootTop + 380 && y < rootEnd - 320;

    var dockAt = window.innerWidth < 760 ? 380 : 620;
    if (dock) dock.classList.toggle('o2-show', y - rootTop > dockAt && inRange);
    if (waBtn) waBtn.classList.toggle('o2-show', y - rootTop > 420 && y < rootEnd);

    if (heroVisual && !REDUCE && y - rootTop < 900) {
      heroVisual.style.transform = 'translateY(' + ((y - rootTop) * -0.045) + 'px)';
    }

    if (cycleSec && scrub) {
      var r = cycleSec.getBoundingClientRect();
      var p = (window.innerHeight * 0.85 - r.top) / (r.height * 0.75);
      p = Math.max(0, Math.min(1, p));
      scrub.style.width = (p * 100) + '%';
      var active = p < .34 ? 0 : (p < .67 ? 1 : 2);
      phases.forEach(function (el, i) { el.classList.toggle('o2-hot', i === active && p > .04); });
    }
    raf = 0;
  }
  window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(onScroll); }, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  /* ---------------------------------------------------------------- init */
  sync();
  onScroll();
})();
